import Phaser from 'phaser';
import { GAME_CONFIG } from '../config/gameConfig';
import PlayScene from './PlayScene';

interface PauseSceneData {
  playScene: PlayScene;
  score: number;
  timeRemaining: number;
}

export default class PauseScene extends Phaser.Scene {
  private playScene?: PlayScene;

  constructor() {
    super({ key: 'PauseScene' });
  }

  init(data: PauseSceneData): void {
    this.playScene = data.playScene;
  }

  create(): void {
    const { width, height } = this.scale;
    
    // 半透明の背景
    const bg = this.add.rectangle(width / 2, height / 2, width, height, 0x000000, 0.7);
    bg.setScrollFactor(0);
    bg.setDepth(200);
    
    // ポーズテキスト
    const pauseText = this.add.text(width / 2, height / 2 - 100, 'PAUSED', {
      fontSize: '64px',
      fontFamily: 'Tiny5',
      color: `#${GAME_CONFIG.colors.text.toString(16).padStart(6, '0')}`,
      fontStyle: 'bold',
    });
    pauseText.setOrigin(0.5);
    pauseText.setScrollFactor(0);
    pauseText.setDepth(201);
    
    // 再開ボタン
    const resumeButton = this.add.rectangle(width / 2, height / 2 + 50, 200, 60, 0xFFD66B, 1);
    resumeButton.setScrollFactor(0);
    resumeButton.setDepth(201);
    resumeButton.setInteractive({ useHandCursor: true });
    resumeButton.on('pointerdown', () => {
      // クリック時に色を変更
      resumeButton.setFillStyle(0xD9B65B, 1);
    });
    resumeButton.on('pointerup', () => {
      // 離した時に色を元に戻し、ボタンの動作を実行
      resumeButton.setFillStyle(0xFFD66B, 1);
      // ボタン効果音を再生
      const buttonSound = this.sound.add('button', { volume: 0.5 });
      buttonSound.play();
      this.resumeGame();
    });
    resumeButton.on('pointerout', () => {
      // ボタン外に出た時に色を元に戻す
      resumeButton.setFillStyle(0xFFD66B, 1);
    });
    resumeButton.on('pointercancel', () => {
      // タッチがキャンセルされた時（スワイプなど）に色を元に戻す
      resumeButton.setFillStyle(0xFFD66B, 1);
    });
    
    const resumeText = this.add.text(width / 2, height / 2 + 50, 'RESUME', {
      fontSize: '32px',
      fontFamily: 'Tiny5',
      color: '#000000',
    });
    resumeText.setOrigin(0.5);
    resumeText.setScrollFactor(0);
    resumeText.setDepth(202);
  }

  private resumeGame(): void {
    if (this.playScene) {
      this.playScene.resumeGame();
    }
    this.scene.stop();
  }
}

